/* LED-BOX 2026 — comportamente pentru componentele custom.
   Fara dependinte. Ruleaza defensiv: daca un element lipseste, nu face nimic. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Sticky add-to-cart
     Apare dupa ce butonul real de ATC iese din viewport.
     Click-ul deleaga catre butonul temei, ca sa pastram cosul AJAX.
     --------------------------------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-lb-sticky]');
    if (!bar) return;

    var realBtn =
      document.querySelector('[data-js-product-add-to-cart]') ||
      document.querySelector('form[action*="/cart/add"] [type="submit"]');
    if (!realBtn) return;

    bar.hidden = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { rootMargin: '0px 0px -100px 0px' }
    );
    observer.observe(realBtn);

    var stickyBtn = bar.querySelector('[data-lb-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        realBtn.click();
      });
    }
  }

  /* ---------------------------------------------------------------
     Bara de transport gratuit
     Re-citeste /cart.js dupa orice adaugare in cos.
     --------------------------------------------------------------- */
  function initShipProgress() {
    var box = document.querySelector('[data-lb-ship]');
    if (!box) return;

    var threshold = parseInt(box.dataset.threshold, 10);
    if (!threshold) return;

    var fill = box.querySelector('[data-lb-ship-fill]');
    var text = box.querySelector('[data-lb-ship-text] span');

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var left = threshold - cart.total_price;
          var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
          if (fill) fill.style.width = pct + '%';
          box.classList.toggle('lb-ship--done', left <= 0);
          if (!text) return;
          text.innerHTML =
            left <= 0
              ? '<strong>Transport gratuit deblocat!</strong> Comanda ta se livrează fără cost.'
              : 'Mai adaugă <strong>' + formatMoney(left) + '</strong> și ai <strong>transport gratuit</strong>.';
        })
        .catch(function () { /* ignora erorile de retea */ });
    }

    // Prinde adaugarile in cos facute prin fetch de catre tema.
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (/\/cart\/(add|change|update)/.test(href)) setTimeout(refresh, 120);
        return res;
      });
    };
  }

  function init() {
    initStickyAtc();
    initShipProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------
   Comutator TVA — afiseaza preturile cu sau fara TVA.
   Doar afisare: cosul si checkout-ul raman pe preturile reale.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var VAT = 1.21;
  var KEY = 'lb-vat-mode';

  function formatRON(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return int + ',' + parts[1] + ' lei';
  }

  function apply(mode) {
    document.querySelectorAll('[data-lb-amount]').forEach(function (el) {
      var cents = parseInt(el.dataset.lbAmount, 10);
      if (isNaN(cents)) return;
      el.textContent = formatRON(mode === 'exc' ? Math.round(cents / VAT) : cents);
    });

    document.querySelectorAll('[data-lb-vat-note]').forEach(function (el) {
      el.textContent = mode === 'exc'
        ? 'Preț fără TVA · TVA-ul se adaugă la finalizarea comenzii'
        : 'Preț cu TVA inclus · Taxa timbru verde inclusă';
    });

    document.querySelectorAll('[data-lb-vat-toggle] [data-lb-vat-mode]').forEach(function (btn) {
      var on = btn.dataset.lbVatMode === mode;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function initVatToggle() {
    if (!document.querySelector('[data-lb-amount]')) return;

    var mode = 'inc';
    try { mode = localStorage.getItem(KEY) || 'inc'; } catch (e) { /* storage blocat */ }

    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-lb-vat-mode]');
      if (!btn) return;
      mode = btn.dataset.lbVatMode;
      try { localStorage.setItem(KEY, mode); } catch (e) { /* storage blocat */ }
      apply(mode);
    });

    if (mode === 'exc') apply(mode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVatToggle);
  } else {
    initVatToggle();
  }
})();

/* ---------------------------------------------------------------
   Scara de preturi pe cantitate
   Un click pe prag seteaza cantitatea din formularul temei.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  function initQtyBreaks() {
    var box = document.querySelector('[data-lb-qty]');
    if (!box) return;

    var input = document.querySelector('input[name="quantity"]');

    function markActive(qty) {
      box.querySelectorAll('[data-lb-qty-set]').forEach(function (b) {
        var on = parseInt(b.dataset.lbQtySet, 10) === qty;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    box.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-lb-qty-set]');
      if (!btn || !input) return;
      var qty = parseInt(btn.dataset.lbQtySet, 10);
      if (!qty) return;
      input.value = qty;
      // Tema asculta 'change' pentru a-si actualiza propriile stari
      input.dispatchEvent(new Event('change', { bubbles: true }));
      markActive(qty);
    });

    // Daca utilizatorul schimba manual cantitatea, marcam pragul atins
    if (input) {
      input.addEventListener('change', function () {
        var q = parseInt(input.value, 10) || 1;
        var best = 1;
        box.querySelectorAll('[data-lb-qty-set]').forEach(function (b) {
          var t = parseInt(b.dataset.lbQtySet, 10);
          if (t <= q && t > best) best = t;
        });
        markActive(best);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQtyBreaks);
  } else {
    initQtyBreaks();
  }
})();

/* ---------------------------------------------------------------
   Mega-meniu: latimea panoului dupa numarul de subcategorii si
   readucerea in ecran a panourilor din dreapta.

   Tema seteaza `left` inline pe panou la deschidere, deci o regula CSS
   de ancorare la dreapta nu are efect. `transform` ramane nefolosit de
   tema, asa ca il folosim ca sa deplasam panoul inapoi in fereastra.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var MARGIN = 16;

  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  function sizePanel(panel) {
    var count = panel.querySelectorAll('.submenu-holder > li').length;
    panel.classList.toggle('lb-mm--sm', count <= 5);
  }

  function clamp(panel) {
    if (!isDesktop()) return;
    panel.style.transform = '';
    // Citim dupa ce tema si-a aplicat pozitia inline
    requestAnimationFrame(function () {
      var r = panel.getBoundingClientRect();
      var overflowRight = r.right - (window.innerWidth - MARGIN);
      if (overflowRight > 0) {
        var shift = Math.min(overflowRight, r.left - MARGIN);
        if (shift > 0) panel.style.transform = 'translateX(' + -shift + 'px)';
      }
    });
  }

  function initMegaMenu() {
    var nav = document.querySelector('.site-nav.style--classic');
    if (!nav) return;

    nav.querySelectorAll('li.has-submenu').forEach(function (li) {
      var panel = li.querySelector(':scope > ul.submenu.normal-menu');
      if (!panel) return;

      sizePanel(panel);

      li.addEventListener('mouseenter', function () { clamp(panel); });
      li.addEventListener('focusin', function () { clamp(panel); });
      li.addEventListener('mouseleave', function () { panel.style.transform = ''; });
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        nav.querySelectorAll('ul.submenu.normal-menu').forEach(function (p) {
          p.style.transform = '';
        });
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();

/* ---------------------------------------------------------------
   Codul de produs de sub titlu urmareste varianta selectata.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  function initSku() {
    var out = document.querySelector('[data-lb-sku]');
    if (!out) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener('change', function () {
      var input = form.querySelector('[name="id"]');
      if (!input) return;
      var id = input.value;
      fetch(window.location.pathname + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).filter(function (x) { return String(x.id) === String(id); })[0];
          if (!v) return;
          var wrap = document.querySelector('[data-lb-sku-wrap]');
          if (v.sku) {
            out.textContent = v.sku;
            if (wrap) wrap.style.display = '';
          } else if (wrap) {
            wrap.style.display = 'none';
          }
        })
        .catch(function () { /* pastram codul afisat */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSku);
  } else {
    initSku();
  }
})();

/* ---------------------------------------------------------------
   Sincronizarea preturilor cu varianta selectata.

   Componenta lb-price e randata o singura data pe server, deci fara
   asta ramanea blocata pe pretul primei variante in timp ce formularul
   trecea pe alta. Actualizeaza pretul, pretul taiat, badge-ul de
   economie, pragurile de cantitate si bara sticky, apoi re-aplica
   modul de afisare cu sau fara TVA.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var VAT = 1.21;

  function formatRON(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1] + ' lei';
  }

  function vatMode() {
    try { return localStorage.getItem('lb-vat-mode') || 'inc'; } catch (e) { return 'inc'; }
  }

  function paint(el, cents) {
    if (!el) return;
    el.dataset.lbAmount = cents;
    el.textContent = formatRON(vatMode() === 'exc' ? Math.round(cents / VAT) : cents);
  }

  function initPriceSync() {
    var holder = document.querySelector('[data-lb-variants]');
    var priceBox = document.querySelector('[data-lb-price]');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!holder || !priceBox || !form) return;

    var variants;
    try { variants = JSON.parse(holder.textContent); } catch (e) { return; }
    if (!variants || variants.length < 2) return;

    var now  = priceBox.querySelector('[data-lb-price-now]');
    var was  = priceBox.querySelector('[data-lb-price-was]');
    var save = priceBox.querySelector('[data-lb-price-save]');
    var saveText = priceBox.querySelector('[data-lb-price-save-text]');

    function update() {
      var input = form.querySelector('[name="id"]');
      if (!input) return;
      var v = variants.filter(function (x) { return String(x.id) === String(input.value); })[0];
      if (!v) return;

      var onSale = v.compare_at_price > v.price;

      paint(now, v.price);
      now.classList.toggle('lb-price__now--sale', onSale);

      if (onSale) {
        paint(was, v.compare_at_price);
        was.hidden = false;
        save.hidden = false;
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        saveText.textContent = 'Economisești ' + formatRON(v.compare_at_price - v.price) + ' (' + pct + '%)';
      } else {
        was.hidden = true;
        save.hidden = true;
        // Golim si textul: daca foaia de stil nu apuca sa se incarce, un badge
        // ramas vizibil ar afisa procentul variantei anterioare.
        saveText.textContent = '';
      }

      // Pragurile de cantitate se calculeaza din pretul de baza
      document.querySelectorAll('[data-lb-qty] [data-lb-qty-set]').forEach(function (tier) {
        var qty = parseInt(tier.dataset.lbQtySet, 10);
        var unitEl = tier.querySelector('.lb-qty__unit');
        var noteEl = tier.querySelector('.lb-qty__note--save');
        if (!unitEl) return;
        if (qty === 1) { paint(unitEl, v.price); return; }
        var pctText = noteEl ? (noteEl.textContent.match(/(\d+)/) || [])[1] : null;
        if (!pctText) return;
        paint(unitEl, Math.round(v.price * (100 - parseInt(pctText, 10)) / 100));
      });

      // Bara sticky
      var stickyPrice = document.querySelector('[data-lb-sticky-price]');
      if (stickyPrice) {
        stickyPrice.innerHTML = (onSale ? '<s>' + formatRON(v.compare_at_price) + '</s> ' : '') + formatRON(v.price);
      }
    }

    form.addEventListener('change', function () { setTimeout(update, 60); });
    // tema poate schimba varianta si prin click pe eticheta, fara eveniment change pe form
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('product-variants, .product-variants')) setTimeout(update, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceSync);
  } else {
    initPriceSync();
  }
})();

/* ===================================================================
   Carusele de produse pe mobil — bara de progres
   Inlocuieste bulinele si sagetile, ascunse pe mobil din CSS (sectiunea 33).
   Bara arata cat din sir ai parcurs; latimea ei = cat din sir e pe ecran.
   =================================================================== */
(function () {
  'use strict';

  var MOBIL = window.matchMedia('(max-width: 767px)');

  function monteaza(slider) {
    if (slider.dataset.lbSwipe) return;
    var holder = slider.querySelector('.css-slider-holder');
    var viewport = slider.querySelector('.css-slider-viewport');
    if (!holder || !viewport) return;
    slider.dataset.lbSwipe = '1';

    var track = document.createElement('div');
    track.className = 'lb-swipe';
    track.setAttribute('aria-hidden', 'true');
    var bar = document.createElement('span');
    bar.className = 'lb-swipe__bar';
    track.appendChild(bar);
    viewport.insertAdjacentElement('afterend', track);

    function deseneaza() {
      var total = holder.scrollWidth;
      var vizibil = holder.clientWidth;
      if (total <= vizibil + 2) {           // nimic de derulat
        track.hidden = true;
        return;
      }
      track.hidden = false;
      var raport = vizibil / total;
      var progres = holder.scrollLeft / (total - vizibil);
      bar.style.width = (raport * 100) + '%';
      // Bara se misca in spatiul ramas: 0 la inceput, (100% - latime) la final.
      bar.style.transform = 'translateX(' + (progres * (1 / raport - 1) * 100) + '%)';
    }
    // Fara requestAnimationFrame: scroll vine deja cel mult o data pe cadru,
    // iar rAF nu ruleaza deloc in taburi din fundal — bara ramanea blocata.
    holder.addEventListener('scroll', deseneaza, { passive: true });
    window.addEventListener('resize', deseneaza, { passive: true });
    deseneaza();
  }

  function init() {
    // Doar caruselele de produse; slideshow-ul si alte slidere raman ale temei.
    document.querySelectorAll('.css-slider').forEach(function (s) {
      if (s.querySelector('.product-item')) monteaza(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Tema monteaza unele slidere tarziu (recomandari incarcate prin fetch).
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
  MOBIL.addEventListener && MOBIL.addEventListener('change', init);
})();

/* ===================================================================
   Notificarea UE privind garantia legala — deschiderea ferestrei.
   <dialog> nativ: Escape si click pe fundal inchid singure fereastra.
   =================================================================== */
(function () {
  'use strict';

  function init() {
    var fereastra = document.querySelector('[data-lb-gue-fereastra]');
    if (!fereastra) return;

    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-lb-gue-deschide]')) {
        ev.preventDefault();
        if (fereastra.showModal) { fereastra.showModal(); } else { fereastra.setAttribute('open', ''); }
        return;
      }
      if (ev.target.closest('[data-lb-gue-inchide]')) {
        fereastra.close ? fereastra.close() : fereastra.removeAttribute('open');
        return;
      }
      // Click pe fundalul ferestrei (in afara continutului) o inchide.
      if (ev.target === fereastra) {
        fereastra.close ? fereastra.close() : fereastra.removeAttribute('open');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
